module.exports = __webpack_public_path__ + "img/jbt7940_1-1995.prt.24dc0934.jpg";